import AboutBanner from "./aboutBanner";
import AboutBadges from "./aboutBadges";
import AboutStory from "./aboutStory";

function About() {
  return (
    <main>
      <AboutBanner />
      <AboutBadges />
      <AboutStory />
    </main>
  );
}

export default About;
